module.exports = __webpack_public_path__ + "img/wendesc.85ea4f88.jpg";